import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

function Cardcmp({incrementVoteCount,...currdata}) {
  return (
    <Card style={{marginBottom:"10px"}}>
      <Card.Header as="h5">{currdata?.department}</Card.Header>
      <Card.Body>
        <Card.Title>{currdata?.topicTitle}</Card.Title>
        <Card.Text>
         {currdata?.description}
        </Card.Text>
        
        <Button variant="secondary" onClick={()=>incrementVoteCount(currdata?.id , currdata?.topicTitle)}>Vote</Button>
      </Card.Body>
    </Card>
  );
}

export default Cardcmp;